import React, { ComponentProps } from 'react';
import { TableExpandHeader as CarbonTableExpandHeader } from '@carbon/react';

export type TableExpandHeaderProps = ComponentProps<
  typeof CarbonTableExpandHeader
>;

export const TableExpandHeader = (props: TableExpandHeaderProps) => (
  <CarbonTableExpandHeader {...props} />
);

TableExpandHeader.displayName = 'TableExpandHeader';
